import React, { useState } from 'react';
import './FloatingButtons.css';
import plus from '../../../images/icons/mob_plus.svg';
import addLead from '../../../images/icons/mb_AddLead.svg';
import addBp from '../../../images/icons/AddBp.svg';
import { navigate } from 'gatsby';
import Modal from '../Modal/modal';
import AddBP from '../AddBpButton/AddBP';

export const addButton = ({ clicked }) => {
  return (
    <div
      onClick={clicked}
      className="add_01 md:hidden fixed  rounded-full w-14 h-14 bg-orange-600 "
    >
      <img
        className="block mx-auto transform rotate-45  mt-2"
        src={plus}
        alt="+"
      />
    </div>
  );
};
export const CloseButton = ({ clicked }) => {
  return (
    <div
      onClick={clicked}
      className="add_01 md:hidden fixed  rounded-full w-14 h-14 bg-orange-600 "
    >
      <img className="block mx-auto  mt-2" src={plus} alt="+" />
    </div>
  );
};
export const AddBp = ({ bpClick }) => {
  const [show, setShow] = useState(false);

  return (
    <div
      onClick={() => {
        setShow(true);
        bpClick(true);
      }}
      className="cont_butt_bp md:hidden fixed hover:bg-grey-1005 flex flex-row justify-end  w-full h-12 "
    >
      <div className="text-base text-white font-roboto font-medium mr-3 mt-3 pt-px ">
        Add Business Partner
      </div>
      <div className="  rounded-full w-10 h-10 mr-8 bg-grey-998 mt-1">
        <img className="block mx-auto  mt-3" src={addBp} alt="+" />
      </div>
      <Modal
        show={show}
        setShow={e => {
          setShow(e), bpClick(e);
        }}
      >
        <AddBP setShow={setShow} />
      </Modal>
    </div>
  );
};

export const AddLead = () => {
  return (
    <div
      onClick={() => navigate('/app/addlead')}
      className="cont_butt_aL  md:hidden fixed hover:bg-grey-1005 flex flex-row justify-end align-center w-full  h-12   "
    >
      <div className="text-base text-white font-roboto font-medium mr-3 mt-3 pt-px">
        Add Lead
      </div>
      <div className="rounded-full w-10 h-10 mr-8 bg-grey-998 mt-1">
        <img className="block mx-auto  mt-3" src={addLead} alt="+" />
      </div>
    </div>
  );
};
